import { create } from "zustand";

const useLayoutStore = create((set) => ({
  isSideNavOpen: false,
  setSideNavOpen: (isSideNavOpen) => set(() => ({ isSideNavOpen })),
}));

export default useLayoutStore;